<template>
	<div></div>
</template>
<script>
export default{
	name: 'remote-js',
	methods: {
		about(index){
			this.$router.push({ path:'/About' + index});
		}	
	}
}
</script>
<style scoped>
</style>
<script>
export default {
	name:"remote-js",
	props: {
		src: { type: String, required: true },
	},
	mounted(){
		const s = document.createElement('script');
		s.type = 'text/javascript';
		s.src = this.src;
		document.body.appendChild(s)
	}
}
</script>
<style>
</style>